import { ProgramCountryLead, ProgramCountryLeadRef } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const assignProgramCountryLead: (
  fetchContext: FetchContext,
  programId: number,
  countryId: number,
  programCountryLead: ProgramCountryLead,
  accessToken?: string,
) => Promise<ProgramCountryLeadRef> = (fetchContext, programId, countryId, programCountryLead, accessToken) => fetch(
  `${fetchContext.baseUrl}/api/staff/programs/${programId}/countries/${countryId}/leads`,
  {
    method: 'POST',
    body: JSON.stringify(programCountryLead),
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  },
).then((response) => responseErrorHandler<ProgramCountryLeadRef>(fetchContext.errorStore, response, 'assign program country lead'));
